module.exports = __webpack_public_path__ + "assets/images/template/placeholder-image.png?v=7f1fffb7";